<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' pageBack='true'></NavBar>
    <div class="detailsContent">
      <UpdateCom :type='type' :id='id'></UpdateCom>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import UpdateCom from '@/components/updateIntroduction'
export default {
  data () {
    return {
      navBlock: '版本更新  /  更新介紹',
      navtitle: '查看',
      type:'edit',
      id: this.$route.query.id,
    }
  },
  components: {
    NavBar,
    UpdateCom
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/version/editIntroduction.vue